export type { TooltipProps } from './tooltip';
export { default } from './tooltip';
